module.exports = __webpack_public_path__ + "img/crm_case9.9110b084.png";